export function getAgents() {
  return require("../agents.json");
}
